import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

export function getAssessmentEvaluationByIdApi(id) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/assessmentEvaluation/${id}`,
    data: id,
  };
  return ApiService(options);
}

export function updateAssessmentEvaluationApi(data) {
  let apiUrl = `${apiBasePath}/assessmentEvaluation/play`;

  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function updateLastActivityApi(id) {
  const options = {
    method: "POST",
    url: `${apiBasePath}/assessmentEvaluation/updateLastActivity/${id}`,
    data: id,
  };
  return ApiService(options);
}
